import React from "react";
import { useHistory } from "react-router-dom";
import { useTracking } from "react-tracking";

import { UserCycleStatus } from "models/user";
import { color } from "style/constants";
import Button from "../Button";

interface ActionButtonProps {
  id: string;
  status: UserCycleStatus;
  isInvalidReview?: boolean;
}

const getLabel = (status: UserCycleStatus): string => {
  switch (status) {
    case UserCycleStatus.assessmentsNull: {
      return "N/A";
    }
    case UserCycleStatus.assessmentsNotStarted: {
      return "N/A";
    }

    case UserCycleStatus.assessmentsInProgress: {
      return "View Details";
    }

    case UserCycleStatus.readyToScore: {
      return "Score";
    }

    case UserCycleStatus.readyForReview: {
      return "Review";
    }
    case UserCycleStatus.scoringInProgress:
    case UserCycleStatus.scoreFinalized: {
      return "View";
    }
  }
};

const ActionButton: React.FC<ActionButtonProps> = ({
  status,
  id,
  isInvalidReview = false
}: ActionButtonProps) => {
  const history = useHistory();
  const tracking = useTracking();

  return (
    <Button
      secondary
      longText
      compressed
      style={{
        minWidth: "100px",
        width: "100%",
        maxWidth: "170px",
        ...(isInvalidReview && {
          backgroundColor: color.RED,
          color: color.WHITE,
          borderColor: color.RED
        })
      }}
      onClick={() => {
        const url = "/user-assessments/" + id;

        tracking.trackEvent({
          url,
          actions: ["Assessments", "Score Assessments", id]
        });

        history.push(url);
      }}
      disabled={
        status === UserCycleStatus.assessmentsNotStarted ||
        status === UserCycleStatus.assessmentsNull
      }
    >
      {isInvalidReview ? "Final Review" : getLabel(status)}
    </Button>
  );
};

export default ActionButton;
